import { useQuery } from '@tanstack/react-query';
import { useApi } from '@backstage/core-plugin-api';
import { techdocsStorageApiRef } from '@backstage/plugin-techdocs-react';
import { LEGACY_DOCS_ENTITY_REF } from '../utils/docCategory';
import { parseMkdocsNav } from '../utils/parseMkdocsNav';

export const LEGACY_DOCS_NAV_QUERY_KEY = 'legacyDocsNav' as const;

// Longer than the plugin default: the nav changes only when the site is built
// again, and each fetch downloads the whole HTML of the site home page.
const LEGACY_DOCS_NAV_STALE_TIME_MS = 30 * 60_000;

/**
 * The nav tree of the legacy Aura docs site, read from the HTML of its home
 * page. The tree has no "Home" item: the docs sidebar links to the site home
 * in its own way. Every docs page reads the same cached result.
 */
export function useLegacyDocsNav() {
  const techdocsStorageApi = useApi(techdocsStorageApiRef);

  return useQuery({
    queryKey: [LEGACY_DOCS_NAV_QUERY_KEY],
    queryFn: async () => {
      const html = await techdocsStorageApi.getEntityDocs(
        LEGACY_DOCS_ENTITY_REF,
        '',
      );
      // The site home is the item with an empty path, whatever its label.
      return parseMkdocsNav(html).filter(node => node.path !== '');
    },
    staleTime: LEGACY_DOCS_NAV_STALE_TIME_MS,
  });
}
